/**
 * useCopy Hook
 * 
 * Provides centralized access to all copy content throughout the application.
 * Returns memoized copy objects to prevent unnecessary re-renders.
 * 
 * Usage:
 * const copy = useCopy();
 * <h1>{copy.publicPages.home.hero.title}</h1>
 */

import { useMemo } from 'react';
import { publicPagesCopy } from '../copy/publicPages';
import { commonCopy } from '../copy/common';
import { accessControlCopy } from '../copy/accessControl';
import { notificationsCopy } from '../copy/notifications';
import { platformPagesCopy } from '../copy/platformPages';

export const useCopy = () => {
  return useMemo(() => ({
    publicPages: publicPagesCopy,
    common: commonCopy,
    accessControl: accessControlCopy,
    notifications: notificationsCopy,
    platformPages: platformPagesCopy,
  }), []);
};